import { BUSD } from './BUSD';
import { ForeignTrading } from './ForeignTrading';
/* eslint-disable */
const indicators = [
  { name: 'OI', code: 'OI', color: '#f49842' },
  { name: 'P/E', code: 'PE', color: '#f49842' },
  { name: 'P/B', code: 'PB', color: '#f49842' },
  { name: 'P/S', code: 'PS', color: '#f49842' },
  { name: 'Net Income', code: 'NetIncome', color: '#f49842' },
  { name: 'Gross Profit', code: 'GrossProfit', color: '#f49842' },
  { name: 'Gross Profit Margin', code: 'GrossProfitMargin', color: '#f49842' },
  { name: 'Net Profit', code: 'NetProfit', color: '#f49842' },
  { name: 'Net Revenue', code: 'NetRevenue', color: '#f49842' },
  { name: 'ROA', code: 'ROA', color: '#f49842' },
  { name: 'ROE', code: 'ROE', color: '#f49842' },
  { name: 'Total Asset', code: 'TotalAsset', color: '#f49842' },
  { name: 'Total Liabilities', code: 'TotalLiabilities', color: '#f49842' },
  { name: 'Total Loans', code: 'TotalLoans', color: '#f49842' },
  { name: 'Total Deposit', code: 'TotalDeposit', color: '#f49842' },
  { name: 'Equity', code: 'Equity', color: '#f49842' },
  { name: 'EBIT Margin', code: 'EBITMargin', color: '#f49842' },
  { name: 'Dividend Yield', code: 'DividendYield', color: '#f49842' },
  { name: 'Net Profit Margin', code: 'NetProfitMargin', color: '#f49842' },
  { name: 'Current Asset', code: 'CurrentAsset', color: '#f49842' },
  { name: 'Current Liabilities', code: 'CurrentLiabilities', color: '#f49842' },
];
export const customIndicatorsGetter = locale => PineJS => {
  const customIndicators = [];
  indicators.forEach(indicator => {
    customIndicators.push({
      name: indicator.name,
      metainfo: {
        _metainfoVersion: 51,
        id: indicator.code + '@tv-basicstudies-1',
        name: indicator.name,
        description: indicator.name,
        shortDescription: indicator.name,
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: {
          type: 'price',
          precision: 1,
        },
        plots: [{ id: 'plot_0', type: 'line' }],
        defaults: {
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 1,
              plottype: 2,
              trackPrice: false,
              transparency: 40,
              color: indicator.color,
            },
          },
          precision: 1,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: indicator.name,
            histogramBase: 0,
          },
        },
        inputs: [],
      },
      constructor: function() {
        this.init = function(context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          var symbol =
            'INDICATOR:' +
            indicator.code +
            ':' +
            PineJS.Std.ticker(this._context);
          this._context.new_sym(
            symbol,
            PineJS.Std.period(this._context),
            PineJS.Std.period(this._context),
          );
        };
        this.main = function(context, inputCallback) {
          this._context = context;
          this._input = inputCallback;
          this._context.select_sym(1);
          const symbolClose = PineJS.Std.close(this._context);
          return [symbolClose];
        };
      },
    });
  });
  return Promise.resolve([
    ...customIndicators,
    BUSD(PineJS),
    ForeignTrading(PineJS, locale),
  ]);
};
/* eslint-enable */
